import {
  SET_CAPITALIZATION_RATE,
} from "./mutations";

const initialState = {
  capitalizationRate: null
};

const capitalizationRateReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_CAPITALIZATION_RATE:
      return { ...state, capitalizationRate: payload }

    default:
      return state;
  }
};

export default capitalizationRateReducer;
